import { useState } from "react";
import SectionHeading from "@/components/feature/SectionHeading";

const faqs = [
  {
    q: "人气榜和热度排行有什么区别？",
    a: "人气榜综合了阅读量、追更数、讨论热度和编辑口碑等多维度数据，更偏重「综合口碑」；热度排行则更关注近期的实时飙升趋势，帮你发现正在快速蹿红的作品。两者结合，既能看清口碑，也能跟上热点。",
  },
  {
    q: "榜单多久更新一次？",
    a: "榜单数据实时采集并滚动更新，热度排行按小时刷新，人气榜每日整点汇总。你可以随时刷新页面查看最新排名，不错过任何一部新作。",
  },
  {
    q: "什么是「必看清单」？",
    a: "必看清单由编辑部从口碑、评分、完本质量与人气中精选，是当前最值得一追的作品合集。跟着清单追，基本不会踩雷，特别适合有选择困难的朋友。",
  },
  {
    q: "高分漫画的评分是怎么来的？",
    a: "评分综合了读者真实评价、编辑评分与作品质量，满分 10 分。评分会随读者反馈动态调整，确保榜单始终反映真实口碑。",
  },
  {
    q: "我想推荐一部好漫画，应该怎么做？",
    a: "欢迎通过「关于我们」页面的联系方式或联系表单告诉我们。编辑部会审核作品品质，一旦入选，就会在对应分类与推荐榜单中展示给更多读者。",
  },
];

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <SectionHeading
          eyebrow="常见问题"
          title="关于榜单，你可能想知道"
          description="整理了几个高频问题，帮你快速了解漫天堂的榜单机制。"
          align="center"
        />
        <div className="grid gap-3">
          {faqs.map((f, i) => {
            const open = openIndex === i;
            return (
              <div
                key={f.q}
                className="overflow-hidden rounded-lg border border-background-200/70 bg-background-50"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? -1 : i)}
                  className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left md:px-6"
                  aria-expanded={open}
                >
                  <h3 className="text-sm font-bold text-foreground-950 md:text-base">{f.q}</h3>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-900 transition-transform ${
                      open ? "rotate-45" : ""
                    }`}
                  >
                    <i className="ri-add-line"></i>
                  </span>
                </button>
                {open && (
                  <p className="px-4 pb-5 text-sm leading-relaxed text-foreground-600 md:px-6">
                    {f.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}